import { useApiPvpList } from "@/api/lctApIComponents";
import { useAppSelector } from "@/hooks/reduxHooks";
import { CarbonScoreMetrics } from "@/dashboard/components/CarbonScoreMetrics";
import { ApplicationOverview } from "../../../components/ApplicationOverview";

export function Dashboard() {
  const token = useAppSelector((state) => state.user.authKey);
  const { data: pvpData } = useApiPvpList({ headers: { Authorization: `Token ${token}` } });

  return (
    <>
      <ApplicationOverview />
      <div>{pvpData?.results.map((pvp) => <CarbonScoreMetrics key={pvp.id} pvp={pvp} />)}</div>
    </>
  );
}
